import { Grid } from 'jrgrid';
import { transferColumns } from '../../utils';
import { pageTransfers } from '../../api';
import Navbar from '../../../../components/Navbar';
import React, { Fragment } from 'react';
import { Loader } from '../../../../components/Loader';
import { Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FilterButtonFilter, FilterButtons } from '../../../Receiving/utils';
import { determineITAdmin } from '../components/determineITAdmin';
export const TransfersPendingApprovalPage = () => {
  const [refresh, setRefresh] = React.useState(false);
  const [itAdmin, setItAdmin] = React.useState(false);

  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));

  React.useEffect(() => {
    setItAdmin(determineITAdmin(user));
  }, []);

  const renderGrid = () => {
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid...' />;
    } else {
      const filter = [
        {
          id: 'updateType',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: 'C',
        },
        {
          id: 'updateStatus',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: 'Transfer Installed, Pending Approval',
        },
      ];

      //further scope the transfered list to the individual deptment if
      //the user is *not* from it
      if (!itAdmin) {
        filter.push({
          id: 'toDeptId',
          type: 'number',
          operand: 'and',
          isLike: false,
          value: `${user.currentRole.departmentId}`,
        });
      }

      return (
        <Grid
          amount={20}
          columns={transferColumns}
          query={pageTransfers}
          queryName='pageTransfers'
          defaultSortField='updateId'
          globalFilters={filter}
          refresh
        />
      );
    }
  };

  const includeAll = itAdmin ? 'viewing all in system' : 'to your department';

  return (
    <Fragment>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <h3 className='mt-3 mb-3 ml-2 mr-2'>
            Transfers Pending Approval <span className='badge badge-info'>{includeAll}</span>
          </h3>
        </Row>
        <div className='ml-2 mr-2'>{renderGrid()}</div>
      </div>
    </Fragment>
  );
};
